/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Name from './Name/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/SimilarPatients/Content/Content/SimilarPerson/Lead/Info/Details"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Details.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Lead"
/>
</div>
{children}
</React.Fragment>)
}